import { axios } from 'api'

export const getProductsByCollection = async (collection_id) =>
  axios.get(`products?collection_id=${collection_id}`)
